import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";
// NOTE: Dynamic inline styles have been removed for CSP compliance.
// Styles must be applied via JavaScript after element creation using _$(el).css().

const Container = htmlE`
  <div
    class="w-full h-full is-flex is-flex-direction-column basket-files-container">
    <main class="basket-files-main bg-primaryMain">
      <div id="basket-filter-container"></div>
      <div
        id="basket-grid-container"
        class="is-relative basket-grid-container"></div>
    </main>
  </div>
`;

const TreeHeader = htmlE`
  <div class="table-responsive h-full list-table bg-primaryMain">
    <table class="table h-full is-flex is-flex-direction-column is-fullwidth">
      <thead>
        <tr class="is-flex">
          <th class="is-cursor-pointer table-header w-38px"></th>
          ${({ canCheckboxColumnDisable }) => {
            if (!canCheckboxColumnDisable) {
              return `<th
            id="checkThBasket"
            class="is-cursor-pointer table-header is-flex is-align-items-center w-38px"
          >
            <input
              class="is-cursor-pointer"
              type="checkbox"
              id="checkAllBasket"
            />
          </th>`;
            }
          }}
          <th
            id="${"prefixId"}-name-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer table-header w-30"
          >
            <p
              data-i18n-key="name"
              class="whitespace-nowrap is-clipped is-ellipsis"
            >
              ${"name"}
            </p>
          </th>
          <th
            id="${"prefixId"}-root_dir-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer table-header w-10"
          >
            <p
              data-i18n-key="path"
              class="whitespace-nowrap is-clipped is-ellipsis"
            >
              ${"path"}
            </p>
          </th>
          <th
            id="${"prefixId"}-size-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer table-header w-15"
          >
            <p
              data-i18n-key="size"
              class="whitespace-nowrap is-clipped is-ellipsis"
            >
              ${"size"}
            </p>
          </th>
          <th
            id="${"prefixId"}-modified-sort-list"
            class="is-inline-flex is-justify-content-space-between is-align-items-center is-cursor-pointer table-header w-20"
          >
            <p
              data-i18n-key="lastModified"
              class="w-full whitespace-nowrap is-clipped is-ellipsis"
            >
              ${"lastModified"}
            </p>
          </th>
          <th
            id="${"prefixId"}-keywords-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer table-header w-20"
          >
            <p
              data-i18n-key="keywords"
              class="w-full whitespace-nowrap is-clipped is-ellipsis"
            >
              ${"keyword"}
            </p>
          </th>
        </tr>
      </thead>
      <tbody class="table-body h-full" id="${"prefixId"}-virtual-list"></tbody>
    </table>
  </div>
`;

const TreeItem = htmlE`
  <td class="table-td remove-item w-38px">
    <i class="icon-remove-sign is-cursor-pointer text-error text-lg"></i>
  </td>
  ${({ canCheckboxColumnDisable, checked }) => {
    if (!canCheckboxColumnDisable) {
      return `
        <td class="table-td check-td w-38px">
          <label for="check" class="is-sr-only">basket-check</label>
          <input ${checked} class="checks is-cursor-pointer" type="checkbox" id="basket-check" />
        </td>
      `;
    }
    return "";
  }}
  <td class="table-td w-30" data-padding-left="${"paddingLeft"}">
    <div tabindex="0" class="w-full is-flex is-align-items-center name">
      <div>
        ${"image"}
      </div>
      <p class="is-clipped is-ellipsis" data-i18n-key="name">${"name"}</p>
    </div>
  </td>
  <td class="table-td w-10">
    <p class="w-full is-clipped is-ellipsis" data-i18n-key="path">${"path"}</p>
  </td>
  <td class="table-td w-15">
    <p class="w-full is-clipped is-ellipsis" data-i18n-key="size">${"sizeFormatted"}</p>
  </td>
  <td class="table-td w-20">
    <p class="w-full is-clipped is-ellipsis" data-i18n-key="lastModified">${"dateFormatted"}</p>
  </td>
  <td class="table-td w-12">
    <p class="w-full is-clipped is-ellipsis" data-i18n-key="keywords">${"keywords"}</p>
  </td>
`;

const ListingTemplatesBasket = {
  Container,
  TreeHeader,
  TreeItem,
};

export default ListingTemplatesBasket;
